import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { supabase } from './supabase';
import { useNavigate } from 'react-router-dom';

var expenseCategories = [
  { key: 'dining', name: '餐饮', color: '#E8956A' },
  { key: 'transport', name: '交通', color: '#7EB5C4' },
  { key: 'shopping', name: '购物', color: '#D4879C' },
  { key: 'entertainment', name: '娱乐', color: '#A68BC1' },
  { key: 'study', name: '学习', color: '#7DB89E' },
  { key: 'medical', name: '医疗', color: '#CF7B7B' },
  { key: 'daily', name: '日用', color: '#C4A882' },
  { key: 'comm', name: '通讯', color: '#8DA4BF' },
  { key: 'clothes', name: '服饰', color: '#D4A0B9' },
  { key: 'snack', name: '零食', color: '#C9A96E' },
  { key: 'other_exp', name: '其他', color: '#9E9E9E' }
];

var incomeCategories = [
  { key: 'salary', name: '工资', color: '#7DB89E' },
  { key: 'bonus', name: '奖金', color: '#E8956A' },
  { key: 'invest', name: '理财', color: '#7EB5C4' },
  { key: 'gift', name: '红包', color: '#D4879C' },
  { key: 'other_in', name: '其他', color: '#9E9E9E' }
];

var allCategories = expenseCategories.concat(incomeCategories);

function getCat(key) {
  return allCategories.find(function(c) { return c.key === key; }) || { key: key, name: key, color: '#9E9E9E' };
}

function currSign(c) {
  if (c === 'CNY') return '\u00A5';
  if (c === 'USD') return '$';
  return 'HK$';
}

function CatIcon({ cat, size }) {
  var s = size || 20;
  var props = { width: s, height: s, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };
  var icons = {
    dining: React.createElement('svg', props, React.createElement('path', { d: 'M3 2l0 7c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V2' }), React.createElement('line', { x1: '5.5', y1: '2', x2: '5.5', y2: '22' }), React.createElement('path', { d: 'M17 2v5.5c0 1.38 1.12 2.5 2.5 2.5H21V2' }), React.createElement('line', { x1: '19', y1: '10', x2: '19', y2: '22' })),
    transport: React.createElement('svg', props, React.createElement('rect', { x: '3', y: '4', width: '18', height: '12', rx: '2' }), React.createElement('path', { d: 'M3 10h18' }), React.createElement('circle', { cx: '7', cy: '20', r: '1' }), React.createElement('circle', { cx: '17', cy: '20', r: '1' }), React.createElement('line', { x1: '7', y1: '16', x2: '7', y2: '19' }), React.createElement('line', { x1: '17', y1: '16', x2: '17', y2: '19' })),
    shopping: React.createElement('svg', props, React.createElement('path', { d: 'M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z' }), React.createElement('line', { x1: '3', y1: '6', x2: '21', y2: '6' }), React.createElement('path', { d: 'M16 10a4 4 0 01-8 0' })),
    entertainment: React.createElement('svg', props, React.createElement('rect', { x: '2', y: '2', width: '20', height: '20', rx: '2.18' }), React.createElement('line', { x1: '7', y1: '2', x2: '7', y2: '22' }), React.createElement('line', { x1: '17', y1: '2', x2: '17', y2: '22' }), React.createElement('line', { x1: '2', y1: '12', x2: '22', y2: '12' }), React.createElement('line', { x1: '2', y1: '7', x2: '7', y2: '7' }), React.createElement('line', { x1: '2', y1: '17', x2: '7', y2: '17' }), React.createElement('line', { x1: '17', y1: '7', x2: '22', y2: '7' }), React.createElement('line', { x1: '17', y1: '17', x2: '22', y2: '17' })),
    study: React.createElement('svg', props, React.createElement('path', { d: 'M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z' }), React.createElement('path', { d: 'M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z' })),
    medical: React.createElement('svg', props, React.createElement('path', { d: 'M18 8h1a4 4 0 010 8h-1' }), React.createElement('path', { d: 'M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z' }), React.createElement('line', { x1: '6', y1: '1', x2: '6', y2: '4' }), React.createElement('line', { x1: '10', y1: '1', x2: '10', y2: '4' }), React.createElement('line', { x1: '14', y1: '1', x2: '14', y2: '4' })),
    daily: React.createElement('svg', props, React.createElement('path', { d: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z' }), React.createElement('polyline', { points: '9 22 9 12 15 12 15 22' })),
    comm: React.createElement('svg', props, React.createElement('rect', { x: '5', y: '2', width: '14', height: '20', rx: '2' }), React.createElement('line', { x1: '12', y1: '18', x2: '12.01', y2: '18' })),
    clothes: React.createElement('svg', props, React.createElement('path', { d: 'M20.38 3.46L16 2 12 5 8 2 3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 001 .84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.14a1 1 0 001-.84l.58-3.47a2 2 0 00-1.34-2.23z' })),
    snack: React.createElement('svg', props, React.createElement('path', { d: 'M18 8h1a4 4 0 010 8h-1' }), React.createElement('path', { d: 'M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z' }), React.createElement('line', { x1: '6', y1: '1', x2: '6', y2: '4' }), React.createElement('line', { x1: '10', y1: '1', x2: '10', y2: '4' }), React.createElement('line', { x1: '14', y1: '1', x2: '14', y2: '4' })),
    other_exp: React.createElement('svg', props, React.createElement('circle', { cx: '12', cy: '12', r: '1' }), React.createElement('circle', { cx: '19', cy: '12', r: '1' }), React.createElement('circle', { cx: '5', cy: '12', r: '1' })),
    salary: React.createElement('svg', props, React.createElement('rect', { x: '2', y: '4', width: '20', height: '16', rx: '2' }), React.createElement('line', { x1: '2', y1: '10', x2: '22', y2: '10' }), React.createElement('line', { x1: '6', y1: '14', x2: '10', y2: '14' })),
    bonus: React.createElement('svg', props, React.createElement('polyline', { points: '20 12 20 22 4 22 4 12' }), React.createElement('rect', { x: '2', y: '7', width: '20', height: '5', rx: '1' }), React.createElement('line', { x1: '12', y1: '22', x2: '12', y2: '7' }), React.createElement('path', { d: 'M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z' }), React.createElement('path', { d: 'M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z' })),
    invest: React.createElement('svg', props, React.createElement('polyline', { points: '22 7 13.5 15.5 8.5 10.5 2 17' }), React.createElement('polyline', { points: '16 7 22 7 22 13' })),
    gift: React.createElement('svg', props, React.createElement('rect', { x: '3', y: '8', width: '18', height: '4', rx: '1' }), React.createElement('path', { d: 'M12 8v13' }), React.createElement('path', { d: 'M19 12v7a2 2 0 01-2 2H7a2 2 0 01-2-2v-7' }), React.createElement('path', { d: 'M7.5 8a2.5 2.5 0 010-5C10 3 12 8 12 8' }), React.createElement('path', { d: 'M16.5 8a2.5 2.5 0 000-5C14 3 12 8 12 8' })),
    other_in: React.createElement('svg', props, React.createElement('circle', { cx: '12', cy: '12', r: '1' }), React.createElement('circle', { cx: '19', cy: '12', r: '1' }), React.createElement('circle', { cx: '5', cy: '12', r: '1' }))
  };
  return icons[cat] || icons.other_exp;
}

// 纯SVG饼图
function DonutChart({ data, size }) {
  var w = size || 180;
  var r = w / 2 - 10;
  var cx = w / 2;
  var cy = w / 2;
  var total = data.reduce(function(s, d) { return s + d.value; }, 0);
  if (total === 0) return React.createElement('div', { style: { width: w, height: w, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text3)', fontSize: 13 } }, '\u6682\u65E0\u6570\u636E');
  var circumference = 2 * Math.PI * r;
  var offset = 0;
  var slices = data.map(function(d, i) {
    var pct = d.value / total;
    var dash = circumference * pct;
    var dashOffset = -offset;
    offset += dash;
    return React.createElement('circle', {
      key: i, cx: cx, cy: cy, r: r,
      fill: 'none', stroke: d.color, strokeWidth: r * 0.45,
      strokeDasharray: dash + ' ' + (circumference - dash),
      strokeDashoffset: dashOffset,
      style: { transition: 'stroke-dasharray 0.6s ease, stroke-dashoffset 0.6s ease' }
    });
  });
  return React.createElement('svg', { width: w, height: w, viewBox: '0 0 ' + w + ' ' + w, style: { transform: 'rotate(-90deg)' } },
    slices,
    React.createElement('circle', { cx: cx, cy: cy, r: r * 0.55, fill: 'var(--card, #fff)' })
  );
}

// 纯SVG柱状图
function BarChartSVG({ data, width, height }) {
  var w = width || 320;
  var h = height || 140;
  var pad = { top: 10, right: 10, bottom: 24, left: 5 };
  var cw = w - pad.left - pad.right;
  var ch = h - pad.top - pad.bottom;
  var maxVal = Math.max.apply(null, data.map(function(d) { return d.value; }).concat([1]));
  var barW = Math.max(4, Math.min(16, (cw / data.length) * 0.6));
  var gap = cw / data.length;
  var bars = data.map(function(d, i) {
    var barH = (d.value / maxVal) * ch;
    var x = pad.left + i * gap + (gap - barW) / 2;
    var y = pad.top + ch - barH;
    return React.createElement('g', { key: i },
      React.createElement('rect', { x: x, y: y, width: barW, height: Math.max(barH, 1), rx: barW / 2, fill: 'var(--accent, #B96747)', opacity: 0.75, style: { transition: 'height 0.4s ease, y 0.4s ease' } }),
      d.label ? React.createElement('text', { x: x + barW / 2, y: h - 4, textAnchor: 'middle', fontSize: 9, fill: 'var(--text3, #9a8b78)' }, d.label) : null
    );
  });
  return React.createElement('svg', { width: '100%', viewBox: '0 0 ' + w + ' ' + h, preserveAspectRatio: 'xMidYMid meet' }, bars);
}

function Ledger() {
  var navigate = useNavigate();
  var [records, setRecords] = useState([]);
  var [loading, setLoading] = useState(true);
  var [currentMonth, setCurrentMonth] = useState(function() {
    var n = new Date();
    return n.getFullYear() + '-' + String(n.getMonth() + 1).padStart(2, '0');
  });
  var [viewMode, setViewMode] = useState('list');
  var [chartPeriod, setChartPeriod] = useState('month');
  var [filterCurrency, setFilterCurrency] = useState('all');
  var [showAdd, setShowAdd] = useState(false);
  var [addType, setAddType] = useState('expense');
  var [addCategory, setAddCategory] = useState('');
  var [addAmount, setAddAmount] = useState('');
  var [addCurrency, setAddCurrency] = useState('HKD');
  var [addNote, setAddNote] = useState('');
  var [addDate, setAddDate] = useState(function() { return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' }); });
  var [deleteTarget, setDeleteTarget] = useState(null);
  var [editTarget, setEditTarget] = useState(null);
  var [yearData, setYearData] = useState([]);
  var [budgets, setBudgets] = useState({});
  var [showBudgetSet, setShowBudgetSet] = useState(false);
  var [budgetInput, setBudgetInput] = useState('');
  var [budgetCurrency, setBudgetCurrency] = useState('HKD');
  var [searchQuery, setSearchQuery] = useState('');
  var [convertTo, setConvertTo] = useState('');
  var [rates, setRates] = useState({ USD: 1, HKD: 7.8, CNY: 7.25 });
  var [lastMonthRecords, setLastMonthRecords] = useState([]);

  useEffect(function() { fetchRecords(); fetchBudgets(); fetchLastMonth(); }, [currentMonth]);
  useEffect(function() { if (chartPeriod === 'year') fetchYearData(); }, [chartPeriod, currentMonth]);
  useEffect(function() { fetchRates(); }, []);

  var fetchRates = async function() {
    try {
      var resp = await fetch('https://open.er-api.com/v6/latest/USD');
      var data = await resp.json();
      if (data && data.rates) setRates({ USD: 1, HKD: data.rates.HKD || 7.8, CNY: data.rates.CNY || 7.25 });
    } catch(e) {}
  };

  var fetchLastMonth = async function() {
    var y = parseInt(currentMonth.split('-')[0]);
    var m = parseInt(currentMonth.split('-')[1]) - 1;
    if (m < 1) { m = 12; y--; }
    var lm = y + '-' + String(m).padStart(2, '0');
    var startDate = lm + '-01';
    var endM = m + 1 > 12 ? 1 : m + 1;
    var endY = m + 1 > 12 ? y + 1 : y;
    var endDate = endY + '-' + String(endM).padStart(2, '0') + '-01';
    var { data } = await supabase.from('ledger').select('*').gte('date', startDate).lt('date', endDate);
    setLastMonthRecords(data || []);
  };

  var convertAmount = function(amount, fromCurrency, toCurrency) {
    if (fromCurrency === toCurrency) return amount;
    var inUSD = amount / rates[fromCurrency];
    return inUSD * rates[toCurrency];
  };

  var fetchRecords = async function() {
    setLoading(true);
    var startDate = currentMonth + '-01';
    var y = parseInt(currentMonth.split('-')[0]);
    var m = parseInt(currentMonth.split('-')[1]);
    var endDate = y + '-' + String(m + 1 > 12 ? 1 : m + 1).padStart(2, '0') + '-01';
    if (m + 1 > 12) endDate = (y + 1) + '-01-01';
    var { data } = await supabase.from('ledger').select('*').gte('date', startDate).lt('date', endDate).order('date', { ascending: false });
    setRecords(data || []);
    setLoading(false);
  };

  var fetchYearData = async function() {
    var y = currentMonth.split('-')[0];
    var { data } = await supabase.from('ledger').select('*').gte('date', y + '-01-01').lt('date', (parseInt(y) + 1) + '-01-01').order('date', { ascending: true });
    setYearData(data || []);
  };

  var fetchBudgets = async function() {
    try {
      var { data } = await supabase.from('ledger_budgets').select('*').eq('month', currentMonth);
      var map = {};
      if (data) data.forEach(function(b) { map[b.currency] = parseFloat(b.amount); });
      setBudgets(map);
    } catch(e) {}
  };

  var saveBudget = async function() {
    if (!budgetInput || isNaN(parseFloat(budgetInput))) return;
    await supabase.from('ledger_budgets').upsert({ month: currentMonth, currency: budgetCurrency, amount: parseFloat(budgetInput) }, { onConflict: 'month,currency' });
    setShowBudgetSet(false);
    setBudgetInput('');
    fetchBudgets();
  };

  var handleAdd = async function() {
    if (!addAmount || !addCategory || isNaN(parseFloat(addAmount))) return;
    if (editTarget) {
      await supabase.from('ledger').update({
        amount: parseFloat(parseFloat(addAmount).toFixed(2)),
        currency: addCurrency, type: addType, category: addCategory,
        note: addNote.trim() || null, date: addDate
      }).eq('id', editTarget.id);
      setEditTarget(null);
    } else {
      await supabase.from('ledger').insert([{
        amount: parseFloat(parseFloat(addAmount).toFixed(2)),
        currency: addCurrency, type: addType, category: addCategory,
        note: addNote.trim() || null, date: addDate,
        created_at: new Date().toISOString()
      }]);
    }
    setShowAdd(false);
    setAddAmount(''); setAddCategory(''); setAddNote(''); setAddType('expense');
    fetchRecords();
  };

  var openEdit = function(r) {
    setEditTarget(r);
    setAddType(r.type);
    setAddCategory(r.category);
    setAddAmount(String(parseFloat(r.amount)));
    setAddCurrency(r.currency);
    setAddNote(r.note || '');
    setAddDate(r.date);
    setShowAdd(true);
  };

  var handleDelete = async function(id) {
    await supabase.from('ledger').delete().eq('id', id);
    setDeleteTarget(null);
    fetchRecords();
  };

  // 筛选后的记录
  var filtered = useMemo(function() {
    var result = records;
    if (filterCurrency !== 'all') result = result.filter(function(r) { return r.currency === filterCurrency; });
    if (searchQuery.trim()) {
      var q = searchQuery.trim().toLowerCase();
      result = result.filter(function(r) {
        var catName = getCat(r.category).name.toLowerCase();
        var note = (r.note || '').toLowerCase();
        return catName.indexOf(q) >= 0 || note.indexOf(q) >= 0;
      });
    }
    return result;
  }, [records, filterCurrency, searchQuery]);

  // 汇率折合总览
  var convertedSummary = useMemo(function() {
    if (!convertTo) return null;
    var totalIncome = 0, totalExpense = 0;
    records.forEach(function(r) {
      var converted = convertAmount(parseFloat(r.amount), r.currency, convertTo);
      if (r.type === 'income') totalIncome += converted;
      else totalExpense += converted;
    });
    return { income: totalIncome, expense: totalExpense, balance: totalIncome - totalExpense, currency: convertTo };
  }, [records, convertTo, rates]);

  // 月度报告数据
  var reportData = useMemo(function() {
    var expenses = records.filter(function(r) { return r.type === 'expense'; });
    if (expenses.length === 0) return null;
    var biggest = expenses.reduce(function(max, r) { return parseFloat(r.amount) > parseFloat(max.amount) ? r : max; }, expenses[0]);
    var catMap = {};
    expenses.forEach(function(r) { catMap[r.category] = (catMap[r.category] || 0) + parseFloat(r.amount); });
    var topCat = Object.keys(catMap).sort(function(a, b) { return catMap[b] - catMap[a]; })[0];
    var totalExp = expenses.reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
    var daysWithRecords = new Set(expenses.map(function(r) { return r.date; })).size;
    var dailyAvg = daysWithRecords > 0 ? totalExp / daysWithRecords : 0;
    var lastExp = lastMonthRecords.filter(function(r) { return r.type === 'expense'; });
    var lastTotal = lastExp.reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
    var diff = lastTotal > 0 ? ((totalExp - lastTotal) / lastTotal * 100) : 0;
    var totalCount = expenses.length;
    return { biggest: biggest, topCat: topCat, topCatAmount: catMap[topCat], totalExp: totalExp, dailyAvg: dailyAvg, lastTotal: lastTotal, diff: diff, totalCount: totalCount };
  }, [records, lastMonthRecords]);

  // 月度统计（按币种）
  var summary = useMemo(function() {
    var result = {};
    ['HKD', 'CNY', 'USD'].forEach(function(c) {
      var cr = records.filter(function(r) { return r.currency === c; });
      var inc = cr.filter(function(r) { return r.type === 'income'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
      var exp = cr.filter(function(r) { return r.type === 'expense'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
      if (inc > 0 || exp > 0) result[c] = { income: inc, expense: exp, balance: inc - exp };
    });
    return result;
  }, [records]);

  // 分类统计（饼图用）
  var categoryStats = useMemo(function() {
    var exp = filtered.filter(function(r) { return r.type === 'expense'; });
    var map = {};
    exp.forEach(function(r) {
      var k = r.category;
      if (!map[k]) map[k] = 0;
      map[k] += parseFloat(r.amount);
    });
    return Object.keys(map).map(function(k) {
      var c = getCat(k);
      return { name: c.name, value: map[k], color: c.color, key: k };
    }).sort(function(a, b) { return b.value - a.value; });
  }, [filtered]);

  // 每日支出（柱状图用）
  var dailyExpense = useMemo(function() {
    var y = parseInt(currentMonth.split('-')[0]);
    var m = parseInt(currentMonth.split('-')[1]);
    var daysInMonth = new Date(y, m, 0).getDate();
    var map = {};
    filtered.filter(function(r) { return r.type === 'expense'; }).forEach(function(r) {
      var day = parseInt(r.date.split('-')[2]);
      map[day] = (map[day] || 0) + parseFloat(r.amount);
    });
    var result = [];
    for (var d = 1; d <= daysInMonth; d++) {
      result.push({ label: d % 5 === 0 || d === 1 ? String(d) : '', value: map[d] || 0 });
    }
    return result;
  }, [filtered, currentMonth]);

  // 按日期分组
  var grouped = useMemo(function() {
    var map = {};
    filtered.forEach(function(r) {
      if (!map[r.date]) map[r.date] = [];
      map[r.date].push(r);
    });
    var dates = Object.keys(map).sort().reverse();
    return dates.map(function(date) {
      var dayTotal = map[date].reduce(function(s, r) { return s + (r.type === 'expense' ? -1 : 1) * parseFloat(r.amount); }, 0);
      return { date: date, records: map[date], total: dayTotal };
    });
  }, [filtered]);

  var monthLabel = function() {
    var parts = currentMonth.split('-');
    return parts[0] + '\u5E74' + parseInt(parts[1]) + '\u6708';
  };

  var shiftMonth = function(dir) {
    var parts = currentMonth.split('-');
    var y = parseInt(parts[0]);
    var m = parseInt(parts[1]) + dir;
    if (m < 1) { m = 12; y--; }
    if (m > 12) { m = 1; y++; }
    setCurrentMonth(y + '-' + String(m).padStart(2, '0'));
  };

  var formatDate = function(d) {
    var parts = d.split('-');
    return parseInt(parts[1]) + '/' + parseInt(parts[2]);
  };

  var weekdayOf = function(d) {
    var w = ['\u65E5', '\u4E00', '\u4E8C', '\u4E09', '\u56DB', '\u4E94', '\u516D'];
    return '\u5468' + w[new Date(d).getDay()];
  };

  // 日历数据
  var calendarData = useMemo(function() {
    var y = parseInt(currentMonth.split('-')[0]);
    var m = parseInt(currentMonth.split('-')[1]);
    var firstDay = new Date(y, m - 1, 1).getDay();
    var daysInMonth = new Date(y, m, 0).getDate();
    var dayMap = {};
    filtered.forEach(function(r) {
      var day = parseInt(r.date.split('-')[2]);
      if (!dayMap[day]) dayMap[day] = { income: 0, expense: 0 };
      if (r.type === 'income') dayMap[day].income += parseFloat(r.amount);
      else dayMap[day].expense += parseFloat(r.amount);
    });
    return { firstDay: firstDay, daysInMonth: daysInMonth, dayMap: dayMap };
  }, [filtered, currentMonth]);

  var totalExpense = filtered.filter(function(r) { return r.type === 'expense'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);

  // 年度月度统计（柱状图用）
  var yearlyMonthStats = useMemo(function() {
    var y = currentMonth.split('-')[0];
    var result = [];
    for (var m = 1; m <= 12; m++) {
      var prefix = y + '-' + String(m).padStart(2, '0');
      var monthRecords = yearData.filter(function(r) { return r.date.startsWith(prefix); });
      if (filterCurrency !== 'all') monthRecords = monthRecords.filter(function(r) { return r.currency === filterCurrency; });
      var exp = monthRecords.filter(function(r) { return r.type === 'expense'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
      var inc = monthRecords.filter(function(r) { return r.type === 'income'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
      result.push({ label: m + '\u6708', expense: exp, income: inc, month: m });
    }
    return result;
  }, [yearData, filterCurrency, currentMonth]);

  var yearTotals = useMemo(function() {
    var fyd = filterCurrency === 'all' ? yearData : yearData.filter(function(r) { return r.currency === filterCurrency; });
    var inc = fyd.filter(function(r) { return r.type === 'income'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
    var exp = fyd.filter(function(r) { return r.type === 'expense'; }).reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
    return { income: inc, expense: exp, balance: inc - exp };
  }, [yearData, filterCurrency]);

  // 本周数据
  var weekStats = useMemo(function() {
    var today = new Date();
    var dayOfWeek = today.getDay();
    var monday = new Date(today);
    monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
    var weekDays = ['\u4E00', '\u4E8C', '\u4E09', '\u56DB', '\u4E94', '\u516D', '\u65E5'];
    var result = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date(monday);
      d.setDate(monday.getDate() + i);
      var ds = d.toLocaleDateString('en-CA');
      var dayRecords = filtered.filter(function(r) { return r.date === ds && r.type === 'expense'; });
      var total = dayRecords.reduce(function(s, r) { return s + parseFloat(r.amount); }, 0);
      result.push({ label: weekDays[i], value: total, date: ds, isToday: ds === today.toLocaleDateString('en-CA') });
    }
    return result;
  }, [filtered]);

  var weekTotal = weekStats.reduce(function(s, d) { return s + d.value; }, 0);

  // 常用分类（快速记账用）
  var frequentItems = useMemo(function() {
    var map = {};
    records.filter(function(r) { return r.type === 'expense'; }).forEach(function(r) {
      var k = r.category + '|' + r.currency;
      if (!map[k]) map[k] = { category: r.category, currency: r.currency, count: 0, lastAmount: parseFloat(r.amount) };
      map[k].count++;
      map[k].lastAmount = parseFloat(r.amount);
    });
    return Object.values(map).sort(function(a, b) { return b.count - a.count; }).slice(0, 4);
  }, [records]);

  return (
    React.createElement('div', { className: 'ledger-page' },
      // 顶部
      React.createElement('div', { className: 'ledger-header' },
        React.createElement('button', { className: 'ledger-back', onClick: function() { navigate(-1); } },
          React.createElement('svg', { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
            React.createElement('polyline', { points: '15 18 9 12 15 6' })
          )
        ),
        React.createElement('div', { className: 'ledger-title' }, '\u8BB0\u8D26'),
        React.createElement('div', { style: { width: 22 } })
      ),

      React.createElement('div', { className: 'ledger-scroll' },
        // 月份选择
        React.createElement('div', { className: 'ledger-month-bar' },
          React.createElement('button', { className: 'month-arrow', onClick: function() { shiftMonth(-1); } },
            React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 }, React.createElement('polyline', { points: '15 18 9 12 15 6' }))
          ),
          React.createElement('span', { className: 'month-label' }, monthLabel()),
          React.createElement('button', { className: 'month-arrow', onClick: function() { shiftMonth(1); } },
            React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 }, React.createElement('polyline', { points: '9 18 15 12 9 6' }))
          )
        ),

        // 总览卡片
        React.createElement('div', { className: 'ledger-summary' },
          Object.keys(summary).length === 0
            ? React.createElement('div', { className: 'summary-empty' }, '\u672C\u6708\u8FD8\u6CA1\u6709\u8BB0\u5F55')
            : Object.keys(summary).map(function(c) {
              var s = summary[c];
              var budget = budgets[c];
              var budgetPct = budget ? Math.min((s.expense / budget) * 100, 100) : 0;
              return React.createElement('div', { key: c, className: 'summary-row' },
                React.createElement('div', { className: 'summary-currency' }, c),
                React.createElement('div', { className: 'summary-items' },
                  React.createElement('div', { className: 'summary-item income' },
                    React.createElement('span', { className: 'summary-label' }, '\u6536\u5165'),
                    React.createElement('span', { className: 'summary-value' }, currSign(c) + s.income.toFixed(2))
                  ),
                  React.createElement('div', { className: 'summary-item expense' },
                    React.createElement('span', { className: 'summary-label' }, '\u652F\u51FA'),
                    React.createElement('span', { className: 'summary-value' }, currSign(c) + s.expense.toFixed(2))
                  ),
                  React.createElement('div', { className: 'summary-item balance' },
                    React.createElement('span', { className: 'summary-label' }, '\u7ED3\u4F59'),
                    React.createElement('span', { className: 'summary-value' + (s.balance < 0 ? ' negative' : '') }, (s.balance >= 0 ? '+' : '') + currSign(c) + Math.abs(s.balance).toFixed(2))
                  )
                ),
                budget ? React.createElement('div', { className: 'budget-bar-wrap' },
                  React.createElement('div', { className: 'budget-bar-bg' },
                    React.createElement('div', { className: 'budget-bar-fill' + (budgetPct >= 90 ? ' danger' : budgetPct >= 70 ? ' warn' : ''), style: { width: budgetPct + '%' } })
                  ),
                  React.createElement('div', { className: 'budget-label' }, '\u9884\u7B97 ' + currSign(c) + budget.toFixed(0) + ' / \u5269\u4F59 ' + currSign(c) + Math.max(0, budget - s.expense).toFixed(0))
                ) : null
              );
            }),
          React.createElement('div', { className: 'summary-actions' },
            React.createElement('button', { className: 'budget-set-btn', onClick: function() { setShowBudgetSet(true); setBudgetInput(''); } }, '\u8BBE\u7F6E\u9884\u7B97'),
            React.createElement('button', { className: 'budget-set-btn', onClick: function() { setConvertTo(convertTo ? '' : 'HKD'); } }, convertTo ? '\u53D6\u6D88\u6298\u5408' : '\u6C47\u7387\u6298\u5408')
          ),
          convertTo && React.createElement('div', { className: 'convert-result' },
            React.createElement('div', { className: 'convert-chips' },
              ['HKD', 'CNY', 'USD'].map(function(c) {
                return React.createElement('button', { key: c, className: 'filter-chip small' + (convertTo === c ? ' active' : ''), onClick: function() { setConvertTo(c); } }, c);
              })
            ),
            convertedSummary && React.createElement('div', { className: 'convert-totals' },
              React.createElement('span', { className: 'convert-item' }, '\u6536\u5165 ' + currSign(convertTo) + convertedSummary.income.toFixed(2)),
              React.createElement('span', { className: 'convert-sep' }, '/'),
              React.createElement('span', { className: 'convert-item expense' }, '\u652F\u51FA ' + currSign(convertTo) + convertedSummary.expense.toFixed(2)),
              React.createElement('span', { className: 'convert-sep' }, '/'),
              React.createElement('span', { className: 'convert-item' + (convertedSummary.balance < 0 ? ' negative' : '') }, '\u7ED3\u4F59 ' + (convertedSummary.balance >= 0 ? '+' : '') + currSign(convertTo) + Math.abs(convertedSummary.balance).toFixed(2))
            )
          )
        ),

        // 币种筛选
        React.createElement('div', { className: 'ledger-filters' },
          ['all', 'HKD', 'CNY', 'USD'].map(function(c) {
            return React.createElement('button', {
              key: c,
              className: 'filter-chip' + (filterCurrency === c ? ' active' : ''),
              onClick: function() { setFilterCurrency(c); }
            }, c === 'all' ? '\u5168\u90E8' : c);
          })
        ),

        // Tab栏
        React.createElement('div', { className: 'ledger-tabs' },
          [
            { key: 'list', label: '\u660E\u7EC6' },
            { key: 'chart', label: '\u56FE\u8868' },
            { key: 'calendar', label: '\u65E5\u5386' },
            { key: 'report', label: '\u62A5\u544A' }
          ].map(function(t) {
            return React.createElement('button', {
              key: t.key,
              className: 'ledger-tab' + (viewMode === t.key ? ' active' : ''),
              onClick: function() { setViewMode(t.key); }
            }, t.label);
          })
        ),

        // 内容区
        viewMode === 'list' && React.createElement('div', { className: 'ledger-list' },
          React.createElement('div', { className: 'search-bar' },
            React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, style: { flexShrink: 0, opacity: 0.4 } },
              React.createElement('circle', { cx: 11, cy: 11, r: 8 }),
              React.createElement('line', { x1: 21, y1: 21, x2: 16.65, y2: 16.65 })
            ),
            React.createElement('input', { className: 'search-input', placeholder: '\u641C\u7D22\u5907\u6CE8\u6216\u5206\u7C7B...', value: searchQuery, onChange: function(e) { setSearchQuery(e.target.value); } }),
            searchQuery && React.createElement('button', { className: 'search-clear', onClick: function() { setSearchQuery(''); } }, '\u00D7')
          ),
          loading ? React.createElement('div', { className: 'ledger-empty' }, '\u52A0\u8F7D\u4E2D...') :
          grouped.length === 0 ? React.createElement('div', { className: 'ledger-empty' }, '\u672C\u6708\u8FD8\u6CA1\u6709\u8BB0\u5F55\uFF0C\u70B9\u53F3\u4E0B\u89D2\u5F00\u59CB\u8BB0\u8D26') :
          grouped.map(function(g) {
            return React.createElement('div', { key: g.date, className: 'day-group' },
              React.createElement('div', { className: 'day-header' },
                React.createElement('span', { className: 'day-date' }, formatDate(g.date) + ' ' + weekdayOf(g.date)),
                React.createElement('span', { className: 'day-total' + (g.total < 0 ? ' negative' : '') }, (g.total >= 0 ? '+' : '') + g.total.toFixed(2))
              ),
              g.records.map(function(r) {
                var cat = getCat(r.category);
                return React.createElement('div', { key: r.id, className: 'record-item' },
                  React.createElement('div', { className: 'record-left', onClick: function() { openEdit(r); } },
                    React.createElement('div', { className: 'record-icon', style: { background: cat.color + '18', color: cat.color } },
                      React.createElement(CatIcon, { cat: r.category, size: 18 })
                    ),
                    React.createElement('div', { className: 'record-info' },
                      React.createElement('div', { className: 'record-cat' }, cat.name),
                      r.note ? React.createElement('div', { className: 'record-note' }, r.note) : null
                    )
                  ),
                  React.createElement('div', { className: 'record-right' },
                    React.createElement('div', { className: 'record-amount' + (r.type === 'income' ? ' income' : '') },
                      (r.type === 'income' ? '+' : '-') + currSign(r.currency) + parseFloat(r.amount).toFixed(2)
                    ),
                    React.createElement('button', { className: 'record-del-btn', onClick: function(e) { e.stopPropagation(); setDeleteTarget(r); } },
                      React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
                        React.createElement('polyline', { points: '3 6 5 6 21 6' }),
                        React.createElement('path', { d: 'M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2' })
                      )
                    )
                  )
                );
              })
            );
          })
        ),

        viewMode === 'chart' && React.createElement('div', { className: 'ledger-chart' },
          // 周/月/年切换
          React.createElement('div', { className: 'chart-period-bar' },
            ['week', 'month', 'year'].map(function(p) {
              var labels = { week: '\u5468', month: '\u6708', year: '\u5E74' };
              return React.createElement('button', {
                key: p, className: 'chart-period-btn' + (chartPeriod === p ? ' active' : ''),
                onClick: function() { setChartPeriod(p); }
              }, labels[p]);
            })
          ),

          // 周视图
          chartPeriod === 'week' && React.createElement('div', null,
            React.createElement('div', { className: 'chart-section' },
              React.createElement('div', { className: 'chart-title-row' },
                React.createElement('span', { className: 'chart-title' }, '\u672C\u5468\u652F\u51FA'),
                React.createElement('span', { className: 'chart-total' }, currSign(filterCurrency === 'all' ? 'HKD' : filterCurrency) + weekTotal.toFixed(2))
              ),
              React.createElement('div', { className: 'week-bars' },
                weekStats.map(function(d, i) {
                  var maxW = Math.max.apply(null, weekStats.map(function(x) { return x.value; }).concat([1]));
                  var pct = (d.value / maxW) * 100;
                  return React.createElement('div', { key: i, className: 'week-bar-row' + (d.isToday ? ' today' : '') },
                    React.createElement('span', { className: 'week-day-label' }, d.label),
                    React.createElement('div', { className: 'week-bar-track' },
                      React.createElement('div', { className: 'week-bar-fill', style: { width: pct + '%' } })
                    ),
                    React.createElement('span', { className: 'week-bar-val' }, d.value > 0 ? d.value.toFixed(0) : '')
                  );
                })
              )
            )
          ),

          // 月视图
          chartPeriod === 'month' && React.createElement('div', null,
            React.createElement('div', { className: 'chart-section' },
              React.createElement('div', { className: 'chart-title' }, '\u652F\u51FA\u5206\u7C7B'),
              React.createElement('div', { className: 'chart-donut-wrap' },
                React.createElement(DonutChart, { data: categoryStats, size: 180 }),
                React.createElement('div', { className: 'chart-legend' },
                  categoryStats.slice(0, 6).map(function(c) {
                    var pct = totalExpense > 0 ? (c.value / totalExpense * 100).toFixed(1) : '0';
                    return React.createElement('div', { key: c.key, className: 'legend-item' },
                      React.createElement('span', { className: 'legend-dot', style: { background: c.color } }),
                      React.createElement('span', { className: 'legend-name' }, c.name),
                      React.createElement('span', { className: 'legend-pct' }, pct + '%')
                    );
                  })
                )
              )
            ),
            React.createElement('div', { className: 'chart-section' },
              React.createElement('div', { className: 'chart-title' }, '\u6BCF\u65E5\u652F\u51FA'),
              React.createElement('div', { className: 'chart-bar-wrap' },
                React.createElement(BarChartSVG, { data: dailyExpense, width: 340, height: 130 })
              )
            )
          ),

          // 年视图
          chartPeriod === 'year' && React.createElement('div', null,
            React.createElement('div', { className: 'chart-section' },
              React.createElement('div', { className: 'chart-title-row' },
                React.createElement('span', { className: 'chart-title' }, currentMonth.split('-')[0] + '\u5E74\u603B\u89C8'),
                React.createElement('span', { className: 'chart-total' }, '\u652F\u51FA ' + yearTotals.expense.toFixed(0))
              ),
              React.createElement('div', { className: 'year-stats' },
                React.createElement('div', { className: 'year-stat income' },
                  React.createElement('span', null, '\u6536\u5165'),
                  React.createElement('span', null, '+' + yearTotals.income.toFixed(2))
                ),
                React.createElement('div', { className: 'year-stat expense' },
                  React.createElement('span', null, '\u652F\u51FA'),
                  React.createElement('span', null, '-' + yearTotals.expense.toFixed(2))
                ),
                React.createElement('div', { className: 'year-stat balance' },
                  React.createElement('span', null, '\u7ED3\u4F59'),
                  React.createElement('span', { className: yearTotals.balance < 0 ? 'negative' : '' }, (yearTotals.balance >= 0 ? '+' : '') + yearTotals.balance.toFixed(2))
                )
              )
            ),
            React.createElement('div', { className: 'chart-section' },
              React.createElement('div', { className: 'chart-title' }, '\u6708\u5EA6\u652F\u51FA\u8D70\u52BF'),
              React.createElement('div', { className: 'chart-bar-wrap' },
                React.createElement(BarChartSVG, { data: yearlyMonthStats.map(function(m) { return { label: m.month + '', value: m.expense }; }), width: 340, height: 150 })
              )
            )
          )
        ),

        viewMode === 'calendar' && React.createElement('div', { className: 'ledger-calendar' },
          React.createElement('div', { className: 'cal-weekdays' },
            ['\u65E5', '\u4E00', '\u4E8C', '\u4E09', '\u56DB', '\u4E94', '\u516D'].map(function(w) {
              return React.createElement('div', { key: w, className: 'cal-wd' }, w);
            })
          ),
          React.createElement('div', { className: 'cal-grid' },
            Array.from({ length: calendarData.firstDay }).map(function(_, i) {
              return React.createElement('div', { key: 'e' + i, className: 'cal-cell empty' });
            }),
            Array.from({ length: calendarData.daysInMonth }).map(function(_, i) {
              var day = i + 1;
              var dd = calendarData.dayMap[day];
              var isToday = currentMonth + '-' + String(day).padStart(2, '0') === new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' });
              return React.createElement('div', { key: day, className: 'cal-cell' + (isToday ? ' today' : '') + (dd ? ' has-data' : '') },
                React.createElement('div', { className: 'cal-day' }, day),
                dd && dd.expense > 0 ? React.createElement('div', { className: 'cal-amount expense' }, '-' + dd.expense.toFixed(0)) : null,
                dd && dd.income > 0 ? React.createElement('div', { className: 'cal-amount income' }, '+' + dd.income.toFixed(0)) : null
              );
            })
          )
        )
      ),

      // 月度报告
      viewMode === 'report' && React.createElement('div', { className: 'ledger-report' },
        !reportData
          ? React.createElement('div', { className: 'ledger-empty' }, '\u672C\u6708\u8FD8\u6CA1\u6709\u652F\u51FA\u8BB0\u5F55')
          : React.createElement('div', null,
            // 总览数字
            React.createElement('div', { className: 'report-card' },
              React.createElement('div', { className: 'report-card-title' }, '\u672C\u6708\u603B\u89C8'),
              React.createElement('div', { className: 'report-big-number' }, currSign(filterCurrency === 'all' ? 'HKD' : filterCurrency) + reportData.totalExp.toFixed(2)),
              React.createElement('div', { className: 'report-sub' }, reportData.totalCount + ' \u7B14\u652F\u51FA'),
              reportData.lastTotal > 0 && React.createElement('div', { className: 'report-diff' + (reportData.diff > 0 ? ' up' : ' down') },
                React.createElement('svg', { width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5 },
                  reportData.diff > 0
                    ? React.createElement('polyline', { points: '18 15 12 9 6 15' })
                    : React.createElement('polyline', { points: '6 9 12 15 18 9' })
                ),
                '\u6BD4\u4E0A\u6708' + (reportData.diff > 0 ? '+' : '') + reportData.diff.toFixed(1) + '%'
              )
            ),

            // 统计项
            React.createElement('div', { className: 'report-card' },
              React.createElement('div', { className: 'report-card-title' }, '\u6D88\u8D39\u6D1E\u5BDF'),
              React.createElement('div', { className: 'report-row' },
                React.createElement('span', { className: 'report-row-label' }, '\u6700\u5927\u5355\u7B14'),
                React.createElement('span', { className: 'report-row-value' }, getCat(reportData.biggest.category).name + ' ' + currSign(reportData.biggest.currency) + parseFloat(reportData.biggest.amount).toFixed(2) + (reportData.biggest.note ? ' (' + reportData.biggest.note + ')' : ''))
              ),
              React.createElement('div', { className: 'report-row' },
                React.createElement('span', { className: 'report-row-label' }, '\u82B1\u6700\u591A\u7684'),
                React.createElement('span', { className: 'report-row-value' }, getCat(reportData.topCat).name + ' (' + currSign(filterCurrency === 'all' ? 'HKD' : filterCurrency) + reportData.topCatAmount.toFixed(0) + ')')
              ),
              React.createElement('div', { className: 'report-row' },
                React.createElement('span', { className: 'report-row-label' }, '\u65E5\u5747\u652F\u51FA'),
                React.createElement('span', { className: 'report-row-value' }, currSign(filterCurrency === 'all' ? 'HKD' : filterCurrency) + reportData.dailyAvg.toFixed(2))
              ),
              reportData.lastTotal > 0 && React.createElement('div', { className: 'report-row' },
                React.createElement('span', { className: 'report-row-label' }, '\u4E0A\u6708\u652F\u51FA'),
                React.createElement('span', { className: 'report-row-value' }, currSign(filterCurrency === 'all' ? 'HKD' : filterCurrency) + reportData.lastTotal.toFixed(2))
              )
            ),

            // 分类排行
            React.createElement('div', { className: 'report-card' },
              React.createElement('div', { className: 'report-card-title' }, '\u5206\u7C7B\u6392\u884C'),
              categoryStats.slice(0, 5).map(function(c, i) {
                var pct = totalExpense > 0 ? (c.value / totalExpense * 100) : 0;
                return React.createElement('div', { key: c.key, className: 'report-rank-row' },
                  React.createElement('span', { className: 'report-rank-num' }, i + 1),
                  React.createElement('span', { className: 'report-rank-dot', style: { background: c.color } }),
                  React.createElement('span', { className: 'report-rank-name' }, c.name),
                  React.createElement('div', { className: 'report-rank-bar-bg' },
                    React.createElement('div', { className: 'report-rank-bar-fill', style: { width: pct + '%', background: c.color } })
                  ),
                  React.createElement('span', { className: 'report-rank-pct' }, pct.toFixed(1) + '%')
                );
              })
            ),

            // 导出按钮
            React.createElement('button', { className: 'export-btn', onClick: function() {
              var url = (process.env.REACT_APP_API_URL || '') + '/api/ledger/export?month=' + currentMonth;
              window.open(url, '_blank');
            }},
              React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', style: { marginRight: 6 } },
                React.createElement('path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }),
                React.createElement('polyline', { points: '7 10 12 15 17 10' }),
                React.createElement('line', { x1: 12, y1: 15, x2: 12, y2: 3 })
              ),
              '\u5BFC\u51FA\u6708\u5EA6\u8D26\u5355 PDF'
            )
          )
      ),
      React.createElement('button', { className: 'ledger-fab', onClick: function() { setShowAdd(true); setAddCategory(''); setAddAmount(''); setAddNote(''); setAddDate(new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' })); } },
        React.createElement('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5, strokeLinecap: 'round' },
          React.createElement('line', { x1: '12', y1: '5', x2: '12', y2: '19' }),
          React.createElement('line', { x1: '5', y1: '12', x2: '19', y2: '12' })
        )
      ),

      // 添加面板 (portal到body，避免WKWebView里transform导致fixed失效)
      showAdd && ReactDOM.createPortal(React.createElement('div', { className: 'add-overlay', style: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.3)', zIndex: 998 }, onClick: function() { setShowAdd(false); } }), document.body),
      showAdd && ReactDOM.createPortal(React.createElement('div', { className: 'add-panel', style: { position: 'fixed', bottom: 0, left: 0, right: 0, width: '100%', zIndex: 999, boxSizing: 'border-box' } },
        React.createElement('div', { className: 'add-panel-drag' }),
        React.createElement('div', { className: 'add-panel-header' },
          React.createElement('span', { className: 'add-panel-title' }, editTarget ? '\u7F16\u8F91' : '\u8BB0\u4E00\u7B14'),
          React.createElement('button', { className: 'add-panel-close', onClick: function() { setShowAdd(false); setEditTarget(null); } }, '\u00D7')
        ),

        // 常用项快速记账
        !editTarget && frequentItems.length > 0 && React.createElement('div', { className: 'quick-items' },
          frequentItems.map(function(item, i) {
            var cat = getCat(item.category);
            return React.createElement('button', { key: i, className: 'quick-item', onClick: function() {
              setAddType('expense'); setAddCategory(item.category); setAddCurrency(item.currency); setAddAmount(String(item.lastAmount));
            }},
              React.createElement('span', { className: 'quick-icon', style: { color: cat.color } }, React.createElement(CatIcon, { cat: item.category, size: 14 })),
              React.createElement('span', { className: 'quick-name' }, cat.name),
              React.createElement('span', { className: 'quick-amt' }, currSign(item.currency) + item.lastAmount.toFixed(0))
            );
          })
        ),

        // 收入/支出切换
        React.createElement('div', { className: 'add-type-bar' },
          React.createElement('button', { className: 'add-type-btn' + (addType === 'expense' ? ' active expense' : ''), onClick: function() { setAddType('expense'); setAddCategory(''); } }, '\u652F\u51FA'),
          React.createElement('button', { className: 'add-type-btn' + (addType === 'income' ? ' active income' : ''), onClick: function() { setAddType('income'); setAddCategory(''); } }, '\u6536\u5165')
        ),

        // 分类选择
        React.createElement('div', { className: 'add-cats' },
          (addType === 'expense' ? expenseCategories : incomeCategories).map(function(c) {
            return React.createElement('div', { key: c.key, className: 'add-cat-item' + (addCategory === c.key ? ' selected' : ''), onClick: function() { setAddCategory(c.key); } },
              React.createElement('div', { className: 'add-cat-icon', style: { color: c.color, background: c.color + '18' } },
                React.createElement(CatIcon, { cat: c.key, size: 20 })
              ),
              React.createElement('div', { className: 'add-cat-name' }, c.name)
            );
          })
        ),

        // 金额 + 币种
        React.createElement('div', { className: 'add-amount-row' },
          React.createElement('div', { className: 'add-currency-select' },
            ['HKD', 'CNY', 'USD'].map(function(c) {
              return React.createElement('button', {
                key: c, className: 'curr-btn' + (addCurrency === c ? ' active' : ''),
                onClick: function() { setAddCurrency(c); }
              }, currSign(c));
            })
          ),
          React.createElement('input', {
            className: 'add-amount-input',
            type: 'number', inputMode: 'decimal', placeholder: '0.00', value: addAmount,
            onChange: function(e) { setAddAmount(e.target.value); },
            autoFocus: true
          })
        ),

        // 备注
        React.createElement('input', {
          className: 'add-note-input',
          placeholder: '\u5907\u6CE8\uFF08\u53EF\u9009\uFF09', value: addNote,
          onChange: function(e) { setAddNote(e.target.value); }
        }),

        // 日期
        React.createElement('input', {
          className: 'add-date-input',
          type: 'date', value: addDate,
          onChange: function(e) { setAddDate(e.target.value); }
        }),

        // 确认
        React.createElement('button', {
          className: 'add-confirm-btn',
          onClick: handleAdd,
          disabled: !addAmount || !addCategory
        }, '\u786E\u5B9A')
      ), document.body),

      // 删除确认 (同样portal到body)
      deleteTarget && ReactDOM.createPortal(React.createElement('div', { className: 'delete-overlay', style: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }, onClick: function() { setDeleteTarget(null); } },
        React.createElement('div', { className: 'delete-dialog', onClick: function(e) { e.stopPropagation(); } },
          React.createElement('div', { className: 'delete-info' },
            React.createElement('span', null, getCat(deleteTarget.category).name),
            React.createElement('span', { className: 'delete-amount' }, (deleteTarget.type === 'income' ? '+' : '-') + currSign(deleteTarget.currency) + parseFloat(deleteTarget.amount).toFixed(2))
          ),
          deleteTarget.note ? React.createElement('div', { className: 'delete-note' }, deleteTarget.note) : null,
          React.createElement('div', { className: 'delete-actions' },
            React.createElement('button', { className: 'delete-cancel', onClick: function() { setDeleteTarget(null); } }, '\u53D6\u6D88'),
            React.createElement('button', { className: 'delete-confirm', onClick: function() { handleDelete(deleteTarget.id); } }, '\u5220\u9664')
          )
        )
      ), document.body),

      // 预算设置弹窗
      showBudgetSet && ReactDOM.createPortal(React.createElement('div', { className: 'delete-overlay', onClick: function() { setShowBudgetSet(false); } },
        React.createElement('div', { className: 'delete-dialog', onClick: function(e) { e.stopPropagation(); }, style: { maxWidth: 300 } },
          React.createElement('div', { style: { fontSize: 15, fontWeight: 600, marginBottom: 14, color: 'var(--text)', fontFamily: 'var(--font-serif)' } }, '\u8BBE\u7F6E\u6708\u5EA6\u9884\u7B97'),
          React.createElement('div', { style: { display: 'flex', gap: 6, marginBottom: 10 } },
            ['HKD', 'CNY', 'USD'].map(function(c) {
              return React.createElement('button', { key: c, className: 'curr-btn' + (budgetCurrency === c ? ' active' : ''), onClick: function() { setBudgetCurrency(c); } }, currSign(c));
            })
          ),
          React.createElement('input', { type: 'number', inputMode: 'decimal', placeholder: '\u9884\u7B97\u91D1\u989D', value: budgetInput, onChange: function(e) { setBudgetInput(e.target.value); }, className: 'add-amount-input', style: { fontSize: 16, width: '100%', marginBottom: 14, boxSizing: 'border-box' } }),
          React.createElement('div', { className: 'delete-actions' },
            React.createElement('button', { className: 'delete-cancel', onClick: function() { setShowBudgetSet(false); } }, '\u53D6\u6D88'),
            React.createElement('button', { className: 'add-confirm-btn', onClick: saveBudget, disabled: !budgetInput, style: { flex: 1, margin: 0 } }, '\u4FDD\u5B58')
          )
        )
      ), document.body),
      React.createElement('style', null, `
.ledger-page { min-height: 100vh; background: var(--bg, #F8F8F6); display: flex; flex-direction: column; }
.ledger-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px; padding-top: max(14px, env(safe-area-inset-top)); position: sticky; top: 0; background: var(--bg, #F8F8F6); z-index: 10; }
.ledger-back { background: none; border: none; color: var(--text, #3d3529); cursor: pointer; padding: 4px; }
.ledger-title { font-size: 17px; font-weight: 600; color: var(--text, #3d3529); letter-spacing: 1px; font-family: var(--font-serif); }
.ledger-scroll { flex: 1; overflow-y: auto; padding: 0 16px 100px; }
.ledger-month-bar { display: flex; align-items: center; justify-content: center; gap: 20px; padding: 8px 0 14px; }
.month-arrow { background: none; border: none; color: var(--text3, #9a8b78); cursor: pointer; padding: 4px; }
.month-label { font-size: 16px; font-weight: 600; color: var(--text, #3d3529); letter-spacing: 0.5px; font-family: var(--font-serif); min-width: 100px; text-align: center; }
.ledger-summary { background: var(--card, #fff); border-radius: 16px; padding: 16px; margin-bottom: 12px; border: 1px solid var(--border, rgba(176,137,104,0.12)); }
.summary-empty { text-align: center; color: var(--text3, #9a8b78); font-size: 13px; padding: 8px 0; }
.summary-row { margin-bottom: 10px; }
.summary-row:last-child { margin-bottom: 0; }
.summary-currency { font-size: 11px; font-weight: 600; color: var(--accent, #B96747); margin-bottom: 6px; letter-spacing: 1px; }
.summary-items { display: flex; gap: 0; }
.summary-item { flex: 1; text-align: center; }
.summary-item:not(:last-child) { border-right: 1px solid var(--border, rgba(176,137,104,0.12)); }
.summary-label { display: block; font-size: 11px; color: var(--text3, #9a8b78); margin-bottom: 3px; }
.summary-value { display: block; font-size: 14px; font-weight: 600; color: var(--text, #3d3529); font-family: var(--font-serif); }
.summary-item.income .summary-value { color: #7DB89E; }
.summary-item.expense .summary-value { color: var(--text, #3d3529); }
.summary-value.negative { color: #CF7B7B; }
.ledger-filters { display: flex; gap: 8px; margin-bottom: 12px; }
.filter-chip { padding: 5px 14px; border-radius: 20px; border: 1px solid var(--border, rgba(176,137,104,0.12)); background: transparent; color: var(--text2, #6b5e4f); font-size: 12px; cursor: pointer; font-family: inherit; transition: all 0.2s; }
.filter-chip.active { background: var(--accent, #B96747); color: white; border-color: var(--accent, #B96747); }
.ledger-tabs { display: flex; gap: 0; margin-bottom: 14px; background: var(--bg2, #F3F3F1); border-radius: 10px; padding: 3px; }
.ledger-tab { flex: 1; padding: 7px 0; border: none; background: transparent; color: var(--text3, #9a8b78); font-size: 13px; font-weight: 500; cursor: pointer; border-radius: 8px; transition: all 0.2s; font-family: inherit; }
.ledger-tab.active { background: var(--card, #fff); color: var(--text, #3d3529); box-shadow: 0 1px 3px rgba(0,0,0,0.06); }
.ledger-empty { text-align: center; color: var(--text3, #9a8b78); font-size: 13px; padding: 50px 0; }
.day-group { margin-bottom: 16px; }
.day-header { display: flex; justify-content: space-between; align-items: center; padding: 6px 4px; margin-bottom: 6px; }
.day-date { font-size: 13px; font-weight: 500; color: var(--text2, #6b5e4f); }
.day-total { font-size: 13px; color: var(--text3, #9a8b78); }
.day-total.negative { color: #CF7B7B; }
.record-item { display: flex; align-items: center; gap: 12px; padding: 12px; background: var(--card, #fff); border-radius: 12px; margin-bottom: 6px; cursor: pointer; transition: transform 0.15s; border: 1px solid var(--border, rgba(176,137,104,0.12)); }
.record-item:active { transform: scale(0.98); }
.record-icon { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.record-info { flex: 1; min-width: 0; }
.record-cat { font-size: 14px; font-weight: 500; color: var(--text, #3d3529); }
.record-note { font-size: 12px; color: var(--text3, #9a8b78); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.record-amount { font-size: 15px; font-weight: 600; color: var(--text, #3d3529); white-space: nowrap; font-family: var(--font-serif); }
.record-amount.income { color: #7DB89E; }
.ledger-chart { padding-bottom: 20px; }
.chart-section { background: var(--card, #fff); border-radius: 16px; padding: 16px; margin-bottom: 12px; border: 1px solid var(--border, rgba(176,137,104,0.12)); }
.chart-title { font-size: 14px; font-weight: 600; color: var(--text, #3d3529); margin-bottom: 14px; font-family: var(--font-serif); }
.chart-donut-wrap { display: flex; align-items: center; gap: 16px; }
.chart-legend { flex: 1; }
.legend-item { display: flex; align-items: center; gap: 8px; padding: 4px 0; }
.legend-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.legend-name { font-size: 12px; color: var(--text2, #6b5e4f); flex: 1; }
.legend-pct { font-size: 12px; color: var(--text3, #9a8b78); font-family: var(--font-serif); }
.chart-bar-wrap { padding: 4px 0; }
.ledger-calendar { background: var(--card, #fff); border-radius: 16px; padding: 14px; border: 1px solid var(--border, rgba(176,137,104,0.12)); }
.cal-weekdays { display: grid; grid-template-columns: repeat(7, 1fr); margin-bottom: 6px; }
.cal-wd { text-align: center; font-size: 11px; color: var(--text3, #9a8b78); padding: 4px 0; }
.cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; }
.cal-cell { aspect-ratio: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; border-radius: 8px; padding: 2px; position: relative; }
.cal-cell.today { background: var(--accent3, rgba(176,137,104,0.08)); }
.cal-cell.today .cal-day { color: var(--accent, #B96747); font-weight: 600; }
.cal-day { font-size: 12px; color: var(--text, #3d3529); }
.cal-amount { font-size: 8px; line-height: 1.2; }
.cal-amount.expense { color: #CF7B7B; }
.cal-amount.income { color: #7DB89E; }
.ledger-fab { position: fixed; bottom: 88px; right: 20px; width: 52px; height: 52px; border-radius: 50%; background: var(--accent, #B96747); color: white; border: none; box-shadow: 0 4px 14px rgba(185,103,71,0.35); cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.15s; z-index: 50; }
.ledger-fab:active { transform: scale(0.9); }
.add-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.3); z-index: 998; }
.add-panel { position: fixed; bottom: 0; left: 0; right: 0; width: 100%; z-index: 999; background: var(--bg, #F8F8F6); border-top-left-radius: 18px; border-top-right-radius: 18px; box-shadow: 0 -4px 24px rgba(0,0,0,0.12); max-height: 80vh; display: flex; flex-direction: column; animation: ledgerSlideUp 0.28s cubic-bezier(0.32,0.72,0,1); overflow: hidden; overflow-x: hidden; box-sizing: border-box; }
.add-panel-drag { display: flex; justify-content: center; padding: 8px 0 2px; }
.add-panel-drag::after { content: ""; width: 36px; height: 4px; border-radius: 2px; background: var(--text4, #c4b8a8); }
.add-panel-header { display: flex; align-items: center; justify-content: space-between; padding: 4px 16px 10px; }
.add-panel-title { font-size: 15px; font-weight: 600; color: var(--text, #3d3529); font-family: var(--font-serif); }
.add-panel-close { background: none; border: none; font-size: 20px; color: var(--text3, #9a8b78); cursor: pointer; padding: 4px 6px; }
.add-type-bar { display: flex; gap: 8px; padding: 0 16px 12px; }
.add-type-btn { flex: 1; padding: 8px 0; border-radius: 10px; border: 1px solid var(--border, rgba(176,137,104,0.12)); background: transparent; color: var(--text3, #9a8b78); font-size: 13px; font-weight: 500; cursor: pointer; font-family: inherit; transition: all 0.2s; }
.add-type-btn.active.expense { background: var(--accent, #B96747); color: white; border-color: var(--accent, #B96747); }
.add-type-btn.active.income { background: #7DB89E; color: white; border-color: #7DB89E; }
.add-cats { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 0 16px 14px; max-height: 160px; overflow-y: auto; }
.add-cat-item { display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer; padding: 8px 4px; border-radius: 10px; transition: background 0.2s; }
.add-cat-item.selected { background: var(--accent3, rgba(176,137,104,0.08)); }
.add-cat-icon { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; transition: transform 0.15s; }
.add-cat-item.selected .add-cat-icon { transform: scale(1.1); }
.add-cat-name { font-size: 11px; color: var(--text2, #6b5e4f); }
.add-amount-row { display: flex; align-items: center; gap: 10px; padding: 0 16px 10px; max-width: 100%; box-sizing: border-box; }
.add-currency-select { display: flex; gap: 4px; flex-shrink: 0; }
.curr-btn { padding: 6px 10px; border-radius: 8px; border: 1px solid var(--border, rgba(176,137,104,0.12)); background: transparent; color: var(--text2, #6b5e4f); font-size: 12px; cursor: pointer; font-family: inherit; transition: all 0.2s; }
.curr-btn.active { background: var(--accent, #B96747); color: white; border-color: var(--accent, #B96747); }
.add-amount-input { flex: 1; min-width: 0; width: 0; border: 1px solid var(--border, rgba(176,137,104,0.12)); border-radius: 10px; padding: 10px 14px; font-size: 20px; font-weight: 600; background: var(--card, #fff); color: var(--text, #3d3529); outline: none; font-family: var(--font-serif); text-align: right; box-sizing: border-box; }
.add-amount-input:focus { border-color: var(--accent, #B96747); }
.add-note-input { margin: 0 16px 10px; border: 1px solid var(--border, rgba(176,137,104,0.12)); border-radius: 10px; padding: 10px 14px; font-size: 13px; background: var(--card, #fff); color: var(--text, #3d3529); outline: none; font-family: inherit; box-sizing: border-box; width: calc(100% - 32px); }
.add-note-input:focus { border-color: var(--accent, #B96747); }
.add-date-input { margin: 0 16px 14px; border: 1px solid var(--border, rgba(176,137,104,0.12)); border-radius: 10px; padding: 10px 14px; font-size: 13px; background: var(--card, #fff); color: var(--text, #3d3529); outline: none; font-family: inherit; box-sizing: border-box; width: calc(100% - 32px); }
.add-date-input:focus { border-color: var(--accent, #B96747); }
.add-confirm-btn { margin: 0 16px 16px; padding: 12px 0; border-radius: 12px; border: none; background: var(--accent, #B96747); color: white; font-size: 15px; font-weight: 600; cursor: pointer; font-family: var(--font-serif); transition: opacity 0.2s; margin-bottom: max(16px, env(safe-area-inset-bottom)); }
.add-confirm-btn:disabled { opacity: 0.4; }
.delete-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); z-index: 1000; display: flex; align-items: center; justify-content: center; }
.delete-dialog { background: var(--card, #fff); border-radius: 14px; padding: 20px 24px; max-width: 280px; width: 90%; box-shadow: 0 4px 20px rgba(0,0,0,0.15); }
.delete-info { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; font-size: 14px; color: var(--text, #3d3529); font-weight: 500; }
.delete-amount { font-family: var(--font-serif); }
.delete-note { font-size: 12px; color: var(--text3, #9a8b78); margin-bottom: 14px; }
.delete-actions { display: flex; gap: 10px; }
.delete-cancel { flex: 1; padding: 9px 0; border-radius: 8px; border: 1px solid var(--border, rgba(176,137,104,0.12)); background: transparent; color: var(--text2, #6b5e4f); font-size: 13px; cursor: pointer; font-family: inherit; }
.delete-confirm { flex: 1; padding: 9px 0; border-radius: 8px; border: none; background: #CF7B7B; color: white; font-size: 13px; cursor: pointer; font-family: inherit; }
@keyframes ledgerSlideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
.budget-bar-wrap { margin-top: 8px; }
.budget-bar-bg { height: 6px; border-radius: 3px; background: var(--bg2, #F3F3F1); overflow: hidden; }
.budget-bar-fill { height: 100%; border-radius: 3px; background: var(--accent, #B96747); transition: width 0.5s ease; }
.budget-bar-fill.warn { background: #E8956A; }
.budget-bar-fill.danger { background: #CF7B7B; }
.budget-label { font-size: 11px; color: var(--text3, #9a8b78); margin-top: 4px; text-align: right; }
.budget-set-btn { width: 100%; margin-top: 10px; padding: 7px 0; border: 1px dashed var(--border, rgba(176,137,104,0.12)); border-radius: 8px; background: transparent; color: var(--text3, #9a8b78); font-size: 12px; cursor: pointer; font-family: inherit; transition: all 0.2s; }
.budget-set-btn:active { background: var(--accent3, rgba(176,137,104,0.08)); }
.chart-period-bar { display: flex; gap: 0; margin-bottom: 14px; background: var(--bg2, #F3F3F1); border-radius: 10px; padding: 3px; }
.chart-period-btn { flex: 1; padding: 6px 0; border: none; background: transparent; color: var(--text3, #9a8b78); font-size: 12px; font-weight: 500; cursor: pointer; border-radius: 8px; transition: all 0.2s; font-family: inherit; }
.chart-period-btn.active { background: var(--card, #fff); color: var(--text, #3d3529); box-shadow: 0 1px 3px rgba(0,0,0,0.06); }
.chart-title-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
.chart-total { font-size: 14px; font-weight: 600; color: var(--accent, #B96747); font-family: var(--font-serif); }
.week-bars { display: flex; flex-direction: column; gap: 8px; }
.week-bar-row { display: flex; align-items: center; gap: 8px; }
.week-bar-row.today .week-day-label { color: var(--accent, #B96747); font-weight: 600; }
.week-day-label { width: 20px; font-size: 12px; color: var(--text2, #6b5e4f); text-align: center; flex-shrink: 0; }
.week-bar-track { flex: 1; height: 18px; background: var(--bg2, #F3F3F1); border-radius: 9px; overflow: hidden; }
.week-bar-fill { height: 100%; background: var(--accent, #B96747); border-radius: 9px; transition: width 0.4s ease; min-width: 2px; opacity: 0.7; }
.week-bar-val { width: 40px; font-size: 11px; color: var(--text3, #9a8b78); text-align: right; flex-shrink: 0; font-family: var(--font-serif); }
.year-stats { display: flex; gap: 0; margin-bottom: 6px; }
.year-stat { flex: 1; text-align: center; padding: 8px 0; }
.year-stat:not(:last-child) { border-right: 1px solid var(--border, rgba(176,137,104,0.12)); }
.year-stat span:first-child { display: block; font-size: 11px; color: var(--text3, #9a8b78); margin-bottom: 4px; }
.year-stat span:last-child { display: block; font-size: 14px; font-weight: 600; color: var(--text, #3d3529); font-family: var(--font-serif); }
.year-stat.income span:last-child { color: #7DB89E; }
.year-stat span.negative { color: #CF7B7B !important; }
.record-left { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0; cursor: pointer; }
.record-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.record-del-btn { background: none; border: none; color: var(--text4, #c4b8a8); padding: 4px; cursor: pointer; transition: color 0.2s; }
.record-del-btn:active { color: #CF7B7B; }
.quick-items { display: flex; gap: 6px; padding: 0 16px 12px; overflow-x: auto; }
.quick-item { display: flex; align-items: center; gap: 5px; padding: 6px 10px; border-radius: 20px; border: 1px solid var(--border, rgba(176,137,104,0.12)); background: var(--card, #fff); cursor: pointer; white-space: nowrap; font-family: inherit; transition: all 0.2s; flex-shrink: 0; }
.quick-item:active { background: var(--accent3, rgba(176,137,104,0.08)); }
.quick-icon { display: flex; align-items: center; }
.quick-name { font-size: 11px; color: var(--text2, #6b5e4f); }
.quick-amt { font-size: 11px; color: var(--text3, #9a8b78); font-family: var(--font-serif); }
.search-bar { display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: var(--card, #fff); border-radius: 10px; margin-bottom: 12px; border: 1px solid var(--border, rgba(176,137,104,0.12)); }
.search-bar .search-input { flex: 1; border: none; background: transparent; font-size: 13px; color: var(--text, #3d3529); outline: none; font-family: inherit; min-width: 0; }
.search-clear { background: none; border: none; color: var(--text3, #9a8b78); font-size: 16px; cursor: pointer; padding: 0 4px; line-height: 1; }
.summary-actions { display: flex; gap: 8px; margin-top: 10px; }
.summary-actions .budget-set-btn { flex: 1; margin-top: 0; }
.convert-result { margin-top: 10px; padding-top: 10px; border-top: 1px solid var(--border, rgba(176,137,104,0.12)); }
.convert-chips { display: flex; gap: 6px; margin-bottom: 8px; }
.filter-chip.small { padding: 3px 10px; font-size: 11px; }
.convert-totals { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.convert-item { font-size: 12px; color: var(--text2, #6b5e4f); font-family: var(--font-serif); }
.convert-item.expense { color: var(--text, #3d3529); font-weight: 500; }
.convert-item.negative { color: #CF7B7B; }
.convert-sep { color: var(--text4, #c4b8a8); font-size: 10px; }
.ledger-report { padding-bottom: 20px; }
.report-card { background: var(--card, #fff); border-radius: 16px; padding: 16px; margin-bottom: 12px; border: 1px solid var(--border, rgba(176,137,104,0.12)); }
.report-card-title { font-size: 14px; font-weight: 600; color: var(--text, #3d3529); margin-bottom: 12px; font-family: var(--font-serif); }
.report-big-number { font-size: 32px; font-weight: 700; color: var(--text, #3d3529); font-family: var(--font-serif); margin-bottom: 2px; }
.report-sub { font-size: 12px; color: var(--text3, #9a8b78); margin-bottom: 8px; }
.report-diff { display: inline-flex; align-items: center; gap: 3px; font-size: 12px; padding: 3px 8px; border-radius: 12px; font-family: var(--font-serif); }
.report-diff.up { background: #CF7B7B18; color: #CF7B7B; }
.report-diff.down { background: #7DB89E18; color: #7DB89E; }
.report-row { display: flex; justify-content: space-between; align-items: center; padding: 8px 0; }
.report-row:not(:last-child) { border-bottom: 1px solid var(--border, rgba(176,137,104,0.06)); }
.report-row-label { font-size: 13px; color: var(--text3, #9a8b78); flex-shrink: 0; }
.report-row-value { font-size: 13px; color: var(--text, #3d3529); text-align: right; font-family: var(--font-serif); }
.report-rank-row { display: flex; align-items: center; gap: 8px; padding: 6px 0; }
.report-rank-num { width: 16px; font-size: 12px; color: var(--text3, #9a8b78); text-align: center; font-family: var(--font-serif); }
.report-rank-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.report-rank-name { width: 40px; font-size: 12px; color: var(--text2, #6b5e4f); flex-shrink: 0; }
.report-rank-bar-bg { flex: 1; height: 14px; background: var(--bg2, #F3F3F1); border-radius: 7px; overflow: hidden; }
.report-rank-bar-fill { height: 100%; border-radius: 7px; transition: width 0.4s ease; opacity: 0.65; }
.report-rank-pct { width: 40px; font-size: 11px; color: var(--text3, #9a8b78); text-align: right; font-family: var(--font-serif); }
.export-btn { display: flex; align-items: center; justify-content: center; width: 100%; padding: 12px 0; border-radius: 12px; border: 1px solid var(--accent, #B96747); background: transparent; color: var(--accent, #B96747); font-size: 14px; font-weight: 500; cursor: pointer; font-family: var(--font-serif); transition: all 0.2s; margin-top: 4px; }
.export-btn:active { background: var(--accent, #B96747); color: white; }
      `)
    )
  );
}

export default Ledger;
